export default "https://cdn-static.gokick.com/assets/e64f1932100d759e3f947f362e9ecc59e4444740/images/tangerine-flavor.d69a41b483f65480106dc4280eb6f29c.png";